import Experiments from '@wix/wix-experiments';

export default new Experiments();
